/* Mublio – maximaal 7 stippen (Design System > Fotogalerij).
   Bij meer dan 7 foto's schuift een venster van 7 stippen mee met de actieve foto.
   De buitenste stip van het venster is kleiner (klasse mb-stip--klein) als er aan die kant nog meer foto's zijn.
   Werkt voor de themagalerijen (.slideshow-controls__dots) en de inspiratiefeed (.mb-post__stippen). */
(() => {
  const MAX = 7;
  const SETS = [
    { box: '.slideshow-controls__dots', item: ':scope > li', actief: (el) => !!el.querySelector('[aria-selected="true"]') },
    { box: '.mb-post__stippen', item: ':scope > span', actief: (el) => el.classList.contains('is-actief') },
  ];

  const bijwerken = (box, set) => {
    const items = [...box.querySelectorAll(set.item)];
    if (items.length <= MAX) {
      items.forEach((el) => {
        el.style.removeProperty('display');
        el.classList.remove('mb-stip--klein');
      });
      return;
    }
    let actief = items.findIndex(set.actief);
    if (actief < 0) actief = 0;
    const start = Math.max(0, Math.min(actief - Math.floor(MAX / 2), items.length - MAX));
    const eind = start + MAX - 1;
    items.forEach((el, n) => {
      if (n < start || n > eind) el.style.display = 'none';
      else el.style.removeProperty('display');
      el.classList.toggle('mb-stip--klein', (n === start && start > 0) || (n === eind && eind < items.length - 1));
    });
  };

  const alles = () => SETS.forEach((set) => document.querySelectorAll(set.box).forEach((box) => bijwerken(box, set)));

  let frame = 0;
  const plan = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      alles();
    });
  };

  const start = () => {
    alles();
    new MutationObserver((lijst) => {
      for (const m of lijst) {
        const doel = m.target;
        if (m.type === 'childList' || (doel.closest && doel.closest('.slideshow-controls__dots, .mb-post__stippen'))) {
          plan();
          return;
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-selected', 'class'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
